import * as React from 'react';
/** @hidden */
export var FormContext = React.createContext(null);
//# sourceMappingURL=FormContext.js.map